<template>
<article>
	<div class="d-flex flex-row justify-content-between align-items-center">
		<img v-if="$store.companyImageUrl" :src="$store.companyImageUrl" class="logo mr-3">
		<div>
			<h2>Scheduled Employees</h2>
			<button class="btn btn-light print-button" v-on:click="printPage">
				<i class="fa fa-print"></i>
				Print
			</button>
		</div>
	</div>

	<h3>{{ serviceId ? "Service" : "Project" }} #{{ job.job_num }}: {{ job.job_name }}</h3>

	<job-schedule-timeline :service-id="serviceId" :project-id="projectId"></job-schedule-timeline>

</article>
</template>
<script type="text/javascript">
import JobScheduleTimeline from "@/components/super_components/JobScheduleTimeline"

export default {
	name: "ScheduleTimelinePrintView",
	components: {
		JobScheduleTimeline
	},
	data() {
		return {
			serviceId: null,
			projectId: null,
			job: null
		}
	},
	methods: {
		printPage() {
			window.print()
		},
		fetchJob() {
			if ("jobType" in this.$route.params) {
				let resource
				if (this.$route.params.jobType == 'service')
					resource = "Service"
				else if (this.$route.params.jobType == 'project')
					resource = "Job"

				this.getJSON(resource+"/find/"+this.$route.params.slug).then(response => {
					if (response.success) {
						if (resource == "Service")
							this.serviceId = response.data.id 
						else if (resource == 'Job')
							this.projectId = response.data.id

						this.job = response.data
					}
				})
			}
		}
	},
	created() {
		this.$store.printMode = true

		this.fetchJob()
	}
}

</script>
<style type="text/css" scoped>

	article {
		max-width: 1000px;
		margin: auto;
	}
	
	@media print {
		.print-button {
			display: none;
		}
	}

</style>